module.exports = __webpack_public_path__ + "3c21aa6704d21aa2900b5ae810f7ada2.png";